'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Toolkit = require('./Toolkit.css');

var _Toolkit2 = _interopRequireDefault(_Toolkit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolkit = (_dec = (0, _reactCssModules2.default)(_Toolkit2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Toolkit, _Component);

  function Toolkit(props) {
    (0, _classCallCheck3.default)(this, Toolkit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Toolkit.__proto__ || (0, _getPrototypeOf2.default)(Toolkit)).call(this, props));

    _this.onCopy = function () {
      _this.setState({ copied: true });
    };

    _this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan. I am writing to raise concerns about tropical deforestation and human rights abuses that may be supported by our current investment policy and about my desire to have options for socially responsible funds.\nDeforestation is a major driver of climate change, biodiversity loss, and attacks on indigenous communities across the tropics. Conversely, maintaining healthy, intact ecosystems is the best prevention we have against both runaway climate change and future pandemics. As the environmental and social effects of deforestation become more widely recognized, investments in the agribusiness companies behind the problem are becoming increasingly risky.\nI [and the attached list of employees] would like to be able to invest in a fund that does not harm forests for purposes of agro-commodity production or sales. Through use of an online tool at deforestationfreefunds.org I was able to analyze many commonly available mutual funds and identify ones that earn a top score regarding deforestation. Importantly, this tool also provides information on funds that are also socially responsible. I note that none of the funds offered in our 401(k) fund are currently forest-safe and socially responsible. In addition to being deforestation-free, I [we] seek a fund that is socially responsible. Socially responsible investing is no longer just an ethical issue, it is a key factor in reducing investment risk and impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.\nSince none of our current plan options are both socially responsible and earn a top rating as deforestation-free, I request that our 401(k) fund plan begin offering one or more such funds in which interested employees can invest. The deforestationfreefunds.org tool is a good option for finding suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]\n[Attachment: Employee/manager letter of support]',
      copied: false
    };
    return _this;
  }

  (0, _createClass3.default)(Toolkit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = '#DefundDeforestation Toolkit';
      var description = 'A How-To Guide to Deforestation Free 401(k)s';
      var url = _config2.default.domain + _config2.default.routes.toolkit;

      var bannerImage = 'green';
      var bannerHeadline = '#DefundDeforestation Toolkit';
      var bannerSubtitle = 'A How-To Guide to Deforestation Free 401(k)s';

      var infographicLarge = require('../../../static/images/large-palm-oil-infographic.jpg');
      var infographicSmall = require('../../../static/images/small-palm-oil-infographic.jpg');

      var message = '#DefundDeforestation Toolkit: A How-To Guide to Deforestation Free 401(k)s';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            '#DefundDeforestation Toolkit'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'subtitle' },
            'A How-To Guide to Deforestation Free 401(k)s'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'h2',
              { styleName: 'answer-title' },
              'How forest-friendly are your 401(k) fund choices?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Your 401(k) portfolio could be an engine for more positive impact. You can help move your employer-sponsored retirement plan to offer deforestation-free and sustainable funds, allowing you to invest your retirement to help build a greener, more just world.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber, and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction. Simultaneously, the occupation of vast areas of land for industrial plantation agriculture is a leading cause of violent land conflicts due to its frequent dispossession and displacement of local and indigenous communities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Simply put, if we want to limit the catastrophic impacts of climate change, reduce our impact on the world\u2019s biodiversity, and respect the rights of indigenous peoples, protecting the world\u2019s remaining forests is key.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation isn\u2019t just bad for the planet. Increasingly, it\u2019s risky business. Companies engaged in deforestation, land grabbing and human rights violations expose themselves and their shareholders to significant financial risks from stalled business operations, reputational damage, and legal liabilities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The industries that drive most deforestation, especially in the tropics, are palm oil, paper/pulp, rubber, timber, cattle, and soy. If it were up to you, your money probably wouldn\u2019t be invested in these industries. But would you know it if it was?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Your savings may be linked to deforestation directly, through investments in ',
              _react2.default.createElement(
                'b',
                null,
                'agricultural commodity producers and traders'
              ),
              ' (companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy); or indirectly, through investments in ',
              _react2.default.createElement(
                'b',
                null,
                'banks'
              ),
              ' that underwrite and lend to deforestation-risk companies, or in ',
              _react2.default.createElement(
                'b',
                null,
                'consumer goods retailers'
              ),
              ' that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'When you think about ensuring that your investments are \u201Cdeforestation-free,\u201D you will need to consider the question \u201Chow deforestation-free can we get?\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For instance, after you look through DeforestationFreeFunds.org, you will see that it can be relatively easy to find funds that are not invested in the direct deforesters (the big agribusiness producers that may actively destroy forests), but it can be much more difficult to find funds that are not invested in the more commonly-held consumer goods companies and banks, which are more indirectly linked to deforestation. However, if funds are invested in the consumer goods companies and banks, fund managers, and you as a shareholder, can actively push these companies towards deforestation-free supply chains \u2013 so pulling your money from all three of the sectors linked to deforestation may not be the only way to support deforestation-free action.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'cntr' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.faq,
                  title: 'Frequently Asked Questions | Deforestation Free Funds'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'faq-btn' },
                  'Frequently asked questions',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'cntr' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: infographicLarge,
                  title: 'Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other \u201Cdeforestation-risk commodities\u201D such as cattle, soy, timber, paper and rubber.'
                },
                _react2.default.createElement('img', {
                  src: infographicSmall,
                  alt: 'Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other \u201Cdeforestation-risk commodities\u201D such as cattle, soy, timber, paper and rubber.',
                  styleName: 'infographic-small'
                })
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'em',
                null,
                'Palm oil is one of the agribusiness sectors drives massive deforestation across the tropics. This graphic could apply just as well to other \u201Cdeforestation-risk commodities\u201D such as cattle, soy, timber, paper and rubber.'
              )
            )
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'section-title' },
            'If your investments are in your employer-sponsored plan'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'If you don\u2019t have an IRA or a personal investment that you control, one of the best ways to make sure you\u2019re not invested in problematic forest-risk companies is to work with your employer to add one or more deforestation-free and socially responsible funds to the list of your employer-offered 401(k) options.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You will need to engage the plan administrator, point them to the right list of funds, and make the case as to why offering such fund options is important. This may take time and possibly some coordination with your co-plan participants. We outline steps below that will help you work with employer to make this happen.'
            )
          ),
          _react2.default.createElement(
            'h3',
            { styleName: 'answer-title' },
            '1) Talk to your colleagues and build a coalition'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'To effectively advocate for deforestation-free offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you\u2019re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest would be sharing results from Deforestation Free Funds with fellow employees. This can be done using social media available on each page of the site. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions right now. It will certainly make interesting conversation over the water-cooler.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some companies have \u201Cgreen teams,\u201D or there may be other employee sponsored affinity groups you could approach. If there isn\u2019t one already, it may be time to create one that can address deforestation. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media. The herd is heard! So, create a petition or letter to the HR manager, the CEO, or your company\u2019s 401(k) manager as a first step. Also, engage those employees most interested in supporting this quest to be allies who will call or write individually, at crucial points in the process, as you move forward.'
            )
          ),
          _react2.default.createElement(
            'h3',
            { styleName: 'answer-title' },
            '2) Identify the best people in the company to speak with'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The 401(k)/403(b) plan administrator, manager, or coordinator should be known to you if you are a plan participant. This is the person that will ultimately have to agree to make the requested change. But, to make sure you have the best chance of success when approaching such managers, in addition to building a coalition of supportive employees, consider building a coalition of support, or a few key allies, within the company. Your company might have a chief sustainability officer or employee engagement manager, which could be good resources in supporting your effort. One effective place to start building allies is to go to LinkedIn pages and find those persons who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations concerned with climate change? Look for indicators that they\u2019re friendly to sustainability and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it\u2019s an important issue for many employees. If it\u2019s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.'
            )
          ),
          _react2.default.createElement(
            'h3',
            { styleName: 'answer-title' },
            '3) Bring a solution to the table'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The usual starting point in these conversations is: \u201CWe want to avoid investing in companies that contribute to deforestation. We also want to reduce the future risk of our 401(k) fund choices. Adding funds to our 401(k) choices that are rated as both deforestation-free and socially responsible on the Deforestation Free Funds tool is an easy way to do so.\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Note that getting three fund choices added to the existing 15-30 is a formal process, and could take up to a year. Larger companies often have some form of investment committee, which engages an investment advisor.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If the investment advisor and plan administrator refuse to help in swapping out funds invested in deforestation-linked agribusiness companies (or fossil fuels, for that matter), you may need to pull out your employee petition, or organize letters or calls from your management supporters to the investment committee. If you are told, \u201CBut you\u2019ll make less money if you\u2019re too focused on environmental issues like deforestation,\u201D you can say, \u201CActually, investing in companies that destroy forests and cause social conflicts is a risky bet, both for the planet and for the long term health of my portfolio. In fact, the Department of Labor recently affirmed that environmental and social factors may have a direct impact on the value of an investment, and can be considered as part of a 401(k) administrator\u2019s fiduciary duty.\u201D'
            )
          ),
          _react2.default.createElement(
            'h3',
            { styleName: 'answer-title-spaceabove' },
            'Sample petition letter to Retirement Plan manager'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'letter-boxquote' },
              _react2.default.createElement(
                'p',
                null,
                'Dear Plan Administrator,'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am an employee of ',
                _react2.default.createElement(
                  'b',
                  null,
                  '[Company Name]'
                ),
                ', and I participate in our company 401(k) plan. I am writing to raise concerns about tropical deforestation and human rights abuses that may be supported by our current investment policy and about my desire to have options for socially responsible funds.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Deforestation is a major driver of climate change, biodiversity loss, and attacks on indigenous communities across the tropics. Conversely, maintaining healthy, intact ecosystems is the best prevention we have against both runaway climate change and future pandemics. As the environmental and social effects of deforestation become more widely recognized, investments in the agribusiness companies behind the problem are becoming increasingly risky.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I [and the attached list of employees] would like to be able to invest in a fund that does not harm forests for purposes of agro-commodity production or sales. Through use of an online tool at ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.home, title: 'Deforestation Free Funds', xstrong: true },
                  'deforestationfreefunds.org'
                ),
                ' I was able to analyze many commonly available mutual funds and identify ones that earn a top score regarding deforestation. Importantly, this tool also provides information on funds that are also socially responsible. I note that none of the funds offered in our 401(k) fund are currently forest-safe and socially responsible. In addition to being deforestation-free, I [we] seek a fund that is socially responsible. Socially responsible investing is no longer just an ethical issue, it is a key factor in reducing investment risk and impacting financial well-being. New guidelines from the Department of Labor state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Since none of our current plan options are both socially responsible and earn a top rating as deforestation-free, I request that our 401(k) fund plan begin offering one or more such funds in which interested employees can invest. The ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.home, title: 'Deforestation Free Funds', xstrong: true },
                  'deforestationfreefunds.org'
                ),
                ' tool is a good option for finding suitable mutual funds that could be included in our plan.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Best,'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  '[Your Name]'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  '[Your contact information (company department, email, phone)]'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  '[Attachment: Employee/manager letter of support]'
                )
              )
            ),
            _react2.default.createElement(
              _reactCopyToClipboard.CopyToClipboard,
              {
                onCopy: this.onCopy,
                text: this.state.value },
              _react2.default.createElement(
                'button',
                {
                  styleName: 'letter-boxquote-copy-button' },
                this.state.copied ? null : _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-files-o' }),
                  '\xA0\xA0\xA0'
                ),
                this.state.copied ? 'Copied!' : 'Copy to clipboard'
              )
            )
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'section-title' },
            'If you\u2019re an individual investor'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'For indiviual investors, it is simpler to reinvest the investments you have in companies that are linked to deforestation. You can trade your own portfolio, or tell your manager to do it. It\u2019s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your holdings and how you would like your holdings changed to align with your values. An investment professional will advise you of potential risk and you can make your decisions.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'They may push back and tell you that you\u2019ll make less money. Again, you can reply, \u201CMaybe, but it\u2019s my money, I want less risk, and if agribusiness is not deforestation-free, then its risky business \u2013 look at fossil fuels and conflict diamonds.\u201D Your financial advisor wants, and it\u2019s their job, to make you money, so you should drive home the point in no uncertain terms. You should also let them know that their fiduciary duty to you includes consideration of your appetite for environmental and social risk. Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to focus on and remove the risk, especially future risk, as well as returns, not a specific fund. If your manager is being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.'
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(_components.AboutBanner, null)
        )
      );
    }
  }]);
  return Toolkit;
}(_react.Component)) || _class);
exports.default = Toolkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Toolkit/Toolkit.js
// module id = 1344
// module chunks = 0